document.addEventListener('page:loaded', function() {

  
/*============================================================================
  FOR ALL PRODUCT IMAGES, ADD A CAPTION (IF INCLUDED)
==============================================================================*/

  var productImages = document.querySelectorAll('.product-main-slide');

  productImages.forEach(function(imgDiv) {
      var caption = imgDiv.querySelector('.caption');
      var img = imgDiv.querySelector('img');
      // slides without an <img> (e.g. video slides) or without an alt
      // attribute would otherwise throw here and silently abort every
      // listener queued after this one in the same page:loaded handler
      if (!caption || !img) {
        return;
      }

      // change the caption
      var captionText = img.getAttribute('alt') || '';

      if (captionText.includes('Caption:')) {
        var correctText = captionText.replace('Caption:', '');
        caption.textContent = correctText;
      }
  });

  
/*============================================================================
  QUICK ADD TO CART - FROM PRODUCT PAGE IN GIFT BOX
==============================================================================*/
  const addCartButtons = document.querySelectorAll("button.gift-box");
  
  addCartButtons.forEach(function(element) {
    console.log('button!', element);
    element.addEventListener('click', event => {
      //event.preventDefault();
  
      var variant_id = element.getAttribute("data-variant-id");

      var result = addItemToCart(variant_id, "1");

      if (result !== 'undefined') {
        element.disabled = true;
        element.innerHTML = "Added to cart";
      }
    });
  });


/*============================================================================
  ADD IS-OPEN CLASS TO PRODUCT DESCRIPTION TAB
==============================================================================*/ 
  var elements = document.querySelectorAll('.product-block .collapsible-trigger:first-child');
  if (elements.length > 0) {
    elements[0].classList.add('is-open');
  }

/*============================================================================
  DETECT WHEN CUSTOMILY CANCEL/SAVE BUTTONS GET CLICKED AND TRIGGER VARIANT CHANGE
==============================================================================*/ 
  
  function setOriginalMonogram(value) {
    var selectedValue = value;
    var orgMonogramRadios = '';
    var option1 = document.querySelectorAll('input[data-index="option1"][name="Monogram"]');
    var option2 = document.querySelectorAll('input[data-index="option2"][name="Monogram"]');
    var option3 = document.querySelectorAll('input[data-index="option3"][name="Monogram"]');

    if (option2.length > 0) {
      orgMonogramRadios = option2;
    } else if (option3.length > 0) {
      orgMonogramRadios = option3;
    } else if (option1.length > 0) {
      orgMonogramRadios = option1;
    }
    
    if (orgMonogramRadios != "") {
      orgMonogramRadios.forEach((orgMono) => {
        if (orgMono.value === selectedValue) {
          orgMono.checked = true;
    
          // Create a new 'change' event
          const changeEvent = new Event('change');
        
          // Dispatch the 'change' event on the radio button, this triggers the variant:change event in the theme.js
          orgMono.dispatchEvent(changeEvent);
        }
      });
    }
    
  }

  // For any product NOT in the Pillows collection, choosing "No Monogram"
  // auto-satisfies the separate checkbox-agreement gate (the one that
  // blocks Add to Cart until checked) - there's nothing to agree to if
  // there's no monogram. Switching back to "Add Monogram" restores the
  // gate so a real monogram order still requires the shopper's agreement.
  // Products in the Pillows collection are left untouched. Declared here
  // (rather than nested inside the `if (noMonoCheckbox)` block below,
  // where it originally lived) so cancelEventListener can also reach it -
  // Cancel needs to re-satisfy the gate exactly like picking "No
  // Monogram" does, since backing out of the popup leaves no monogram
  // either.
  function syncCheckboxGateForMonogram(isNoMonogram) {
    if (typeof productInPillowsCategory !== 'undefined' && productInPillowsCategory) {
      return;
    }
    var gateCheckbox = document.querySelector('[data-add-to-cart-gate]');
    if (!gateCheckbox || gateCheckbox.checked === isNoMonogram) {
      return;
    }
    gateCheckbox.checked = isNoMonogram;
    gateCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function cancelEventListener() {
    console.log('Cancel button clicked!');
    // Perform actions for inner button click here
    setOriginalMonogram('No Monogram');

    // Cancelling out of the popup means no monogram was actually added -
    // put the checkbox agreement back the way choosing "No Monogram"
    // would, even though the shopper never touched that control directly.
    var noMono = document.getElementById('noMonogram');
    if (noMono) {
      noMono.checked = true;
    }
    syncCheckboxGateForMonogram(true);
  }

  function saveEventListener() {
    console.log('Save button clicked!');
    // Perform actions for inner button click here
    setOriginalMonogram('Add Monogram');
  }

  function outerEventListener() {
    console.log('Monogram button clicked!');
    // Perform actions for outer button click here

    setTimeout(function() {
      var cancelButton = document.getElementById('customily-cancel-button');
      cancelButton.addEventListener('click', cancelEventListener);
  
      var saveButton = document.getElementById('customily-save-button');
      saveButton.addEventListener('click', saveEventListener);
    }, 1000); // Delay of 1000 milliseconds (1 second)

    
  }

  var outerButton = document.getElementById('addMonogram');
  if (outerButton) {
    outerButton.addEventListener('click', outerEventListener);
  }
  

  var noMonoCheckbox = document.getElementById('noMonogram');
  if (noMonoCheckbox) {
    var addMonoCheckbox = document.getElementById('addMonogram');
    var monogramChoiceMade = false;

    // the "checked" attribute is set in the markup, but Customily (loaded
    // async, outside theme code) resets this radio's live .checked property
    // to false sometime after its own init finishes, which leaves
    // .checkmark:after not showing until the shopper clicks it manually.
    // Keep re-asserting the default for a few seconds to outlast whenever
    // Customily's init happens to run, and stop the moment the shopper
    // actually picks an option themselves.
    function enforceDefaultMonogramChoice() {
      if (monogramChoiceMade) {
        return;
      }
      if (!addMonoCheckbox || !addMonoCheckbox.checked) {
        noMonoCheckbox.checked = true;
        syncCheckboxGateForMonogram(true);
      }
    }

    enforceDefaultMonogramChoice();

    var monogramEnforceInterval = window.setInterval(enforceDefaultMonogramChoice, 300);
    window.setTimeout(function () {
      window.clearInterval(monogramEnforceInterval);
    }, 8000);

    noMonoCheckbox.addEventListener('click', function () {
      monogramChoiceMade = true;
      setOriginalMonogram('No Monogram');
      syncCheckboxGateForMonogram(true);
    });

    if (addMonoCheckbox) {
      addMonoCheckbox.addEventListener('click', function () {
        monogramChoiceMade = true;
        syncCheckboxGateForMonogram(false);
      });
    }
  }


});


// Puts the monogram controls back to their untouched, freshly-loaded state
// after a successful AJAX add to cart - without this, "No Monogram" would
// stay unchecked and the Customily popup would still remember whatever
// style tab the shopper left it on if they configure another item next.
// Dispatching a synthetic click on #noMonogram (rather than calling the
// reset helpers directly) reuses the exact same code path as a shopper
// clicking "No Monogram" themselves - both the variant/checkbox-gate reset
// above and the capturing document click listener that resets the
// Customily popup to its first tab (see needsFreshStyleChoice in
// buildTabs() below). Note this only resets what the theme itself
// controls; any deeper per-style selections already cached inside
// Customily's own Vue widget for THIS still-open popup instance are
// outside our reach without a page reload.
//
// Deliberately NOT noMono.click() - that synthesizes a *bubbling* click,
// and theme.js's cart-drawer-open handling has its own document/window
// click listener that closes the drawer on any click landing outside it
// (see theme.Drawers.prototype.bindEvents). Confirmed live: using .click()
// here closed the drawer the instant it opened, since this listener fires
// inside the same ajaxProduct:added dispatch that opens it. A non-bubbling
// event still reaches both listeners above (capturing fires top-down
// regardless of bubbles, and a listener bound directly on the target
// itself always fires during the target phase) without ever reaching
// window's bubble-phase listener.
document.addEventListener('ajaxProduct:added', function() {
  var noMono = document.getElementById('noMonogram');
  if (noMono) {
    noMono.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
  }
});


document.addEventListener('recommendations:loaded', function(evt) {
  console.log(evt.detail);

/*============================================================================
  SHOW COMPLETE YOUR COLLECTION, WHEN WE HAVE PRODUCT VARIANT RECS AND NO COMPLEMENTARY PRODUCTS
==============================================================================*/
  //if (meta_data_add_to_cart && meta_data_design_your_own) {
   // if (Object.keys(meta_data_add_to_cart).length != 0 && Object.keys(meta_data_design_your_own).length != 0) {
   //  document.querySelector('[data-section-type="product-recommendations"]').classList.remove('hide');
   // }
  //} 
  
  addCartButtonClickHandler();


});

document.addEventListener('variant:change', function(evt) {

/*============================================================================
 DISPLAY RECOMMENDED PRODUCT
==============================================================================*/
  // remove all old variant recs
  const allrecs = document.querySelectorAll('.variant-rec');
  allrecs.forEach(function(element) {
    element.remove();
  });
  
  var thisVariant = evt.detail.variant.id;
  addCartButtonClickHandler();

  //geteGiftLink(thisVariant);

  //console.log(thisVariant);

/*============================================================================
 REMOVE MONOGRAMMING OPTION FOR DR MARY SILK PILLOW CASE 
 AND SHEET SET AND DUVET COVER BUNDLE
==============================================================================*/
  //console.log("event detail variant", evt.detail.variant); 

  if (evt.detail.variant.id == "45705140732220") {
    const button = document.getElementById("addMonogram");
    const orgMono = document.querySelectorAll('input[data-index="option3"][name="Monogram"][value="No Monogram"]');
    const noMono = document.getElementById("noMonogram");

    // Disable the button (products without a monogram option don't have this element)
    if (button) {
      button.disabled = true;
      button.parentNode.classList.add("disabled");
    }

    if (noMono) {
      noMono.checked = true;
    }

    // Trigger the radio click
    if (typeof orgMono !== 'undefined') {

      orgMono.checked = true;

      // Create a new 'change' event
      //const changeEvent = new Event('change');

      // Dispatch the 'change' event on the radio button, this triggers the variant:change event in the theme.js
      //orgMono.dispatchEvent(changeEvent);
    }


  } else if (evt.detail.variant.id == "46749036544316" || evt.detail.variant.id == "46749036806460" ) {
    const button = document.getElementById("addMonogram");
    const noMono = document.getElementById("noMonogram");

    // Disable the button (products without a monogram option don't have this element)
    if (button) {
      button.disabled = true;
      button.parentNode.classList.add("disabled");
    }

    if (noMono) {
      noMono.checked = true;
    }

  } else {
    const button = document.getElementById("addMonogram");

    // Disable the button (products without a monogram option don't have this element)
    if (button) {
      button.disabled = false;
      button.parentNode.classList.remove("disabled");
    }

  }

/*============================================================================
 FORCE MONOGRAMMING TO BE CHOSEN AGAIN ON VARIANT CHANGE,
 FOR PRODUCTS: 
   TRAVEL PILLOW PROTECTOR 
   COTTON SATEEN PILLOW CASE
==============================================================================*/
  if (evt.detail.variant.id == "45714945933628" || evt.detail.variant.id == "45714945966396" || evt.detail.variant.id == "45714946097468" || evt.detail.variant.id == "45714946425148" || evt.detail.variant.id == "45714946261308" || evt.detail.variant.id == "45714946588988" || evt.detail.variant.id == "45639640482108" || evt.detail.variant.id == "45639640613180" || evt.detail.variant.id == "45639641203004" || evt.detail.variant.id == "45639640908092" || evt.detail.variant.id == "45639641039164" || evt.detail.variant.id == "45639640744252" || evt.detail.variant.id == "45639641792828" || evt.detail.variant.id == "45639641530684" || evt.detail.variant.id == "45639640351036") {
    // Turns button white again (products without a monogram option don't have this element)
    var addMonogramButton = document.querySelector('#addMonogram');
    if (addMonogramButton) {
      addMonogramButton.parentNode.classList.remove('pb-button_tertiary');
    }

    // Uncheck 'Add Monogram' checkbox
    var addMonogramCheckbox = document.querySelector('input[name="monogramming"][value="Add Monogram"]');
    if (addMonogramCheckbox) {
      addMonogramCheckbox.checked = false;
    }

    // Check 'No Monogram' checkbox
    var noMonogramCheckbox = document.querySelector('input[name="monogramming"][value="No Monogram"]');
    if (noMonogramCheckbox) {
      noMonogramCheckbox.checked = true;
    }
  }

});

document.addEventListener('tooltip:open', function(evt) {
  // console.log(evt.detail);
});




/*============================================================================
  FUNCTION FOR ADDING ITEM TO CART
==============================================================================*/
function addItemToCart(variant_id, qty) {
  var data = {
    "id": variant_id,
    "quantity": qty
  };

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(function(response) {
    if (!response.ok) {
      throw new Error('Error adding item to cart');
    }
    return response.json();
  })
  .then(function(product) {
    // this is the event the theme's cart drawer / sticky cart actually
    // listen for (see theme.CartDrawer / theme.StickyCart in theme.js);
    // cart:refresh, dispatched previously, has no listeners
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product
      }
    }));

    return product;
  })
  .catch(function(error) {
    console.error(error);
    throw error;
  });
}

/*============================================================================
  FUNCTION FOR GETTING PRODUCT INFO BY ID, USING STOREFRONT API
==============================================================================*/

function getProductById(productId, type) {
  var storefrontAccessToken = '9160aa744f5b30a0a041da3ba3b46d82';
  var productId = productId;
  var query = `
   {
    node(id: "${productId}") {
      ... on ProductVariant {
        id
        title
        availableForSale
        product{
          title
          handle
        }
        image{
          url
        }
      }
    }
  }
  `;
  
  
  fetch('https://the-pillow-bar-shop.myshopify.com/api/2026-10/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({
      query: query
    })
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
    
    const productVariant = data.data; 

    if (productVariant) {
      // Accessing top-level properties
      const node = data.data.node;
      const variantId = node.id;
      var number = variantId.match(/\d+$/)[0];

      const availableForSale = node.availableForSale;
      const imageUrl = node.image.url;
      const title = node.product.title;
      const variantTitle = node.title;
      const productUrl = node.product.handle;

      //console.log('Product Title:', title);
      //console.log('Product Image URL:', imageUrl);

      //var newContent = '';
      // create a div to replace current
      //if (type == 'add') {
      //    var newContent = "<div class='flex-block flex-center variant-rec'><img width='180' src='" + imageUrl + "' /><div><h4>" + title + "</h4><button class='quick-add-to-cart pb-button' data-variant-id='" + number + "'>ADD TO CART</button></div></div>";

      //} else {
      //   var newContent = "<div class='flex-block flex-center variant-rec'><img width='180' src='" + imageUrl + "' /><div><h4>" + title + "</h4><a href='" + productUrl + "?variant=" + number +"' class='h6 purple arrow-link'>DESIGN YOUR OWN</a></div></div>";
      //}
      //$(".product-recommendations-placeholder").prepend(newContent);
      addCartButtonClickHandler();

      
    } else {
      console.error('Product not found.');
    }
  })
  .catch(function(error) {
    console.error('Error fetching product data:', error);
  });
}

/*============================================================================
  QUICK ADD TO CART CLICK HANDLER
==============================================================================*/
function addCartButtonClickHandler() {
  const addCartButtons = document.querySelectorAll("button.quick-add-to-cart");

  addCartButtons.forEach(function(element) {
    // this function gets called again whenever recommendations reload or
    // the variant changes; skip buttons that already have a listener so
    // clicks don't fire multiple /cart/add.js requests
    if (element.dataset.quickAddBound) {
      return;
    }
    element.dataset.quickAddBound = 'true';

    element.addEventListener('click', event => {
      event.preventDefault();

      if (element.disabled) {
        return;
      }

      var variant_id = element.getAttribute("data-variant-id");
      var originalText = element.innerHTML;
      element.disabled = true;

      addItemToCart(variant_id, "1")
        .then(function() {
          element.innerHTML = "Added to cart";
        })
        .catch(function() {
          element.disabled = false;
          element.innerHTML = originalText;
        });
    });
  });
}



/*============================================================================
  CHANGE GIFT CARD LINK
==============================================================================*/
function geteGiftLink(productId) {
  var storefrontAccessToken = '9160aa744f5b30a0a041da3ba3b46d82';
  var productId = 'gid://shopify/ProductVariant/' + productId;
  var query = `
   {
      node(id: "${productId}") {
      ... on ProductVariant {
        id
        title
        metafield(namespace: "custom", key: "e_gift_card_option") {
          value
          type
        }
      }
    }
    }
  `;
  
  
  fetch('https://the-pillow-bar-shop.myshopify.com/api/2026-10/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({
      query: query
    })
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {

    const metafield = data.data.node.metafield.value;
    if (metafield != null) {

      // Remove everything but the last numbers
      var numbers = metafield.replace(/\D/g, '');

      $(".gift-item").attr("href", "https://the-pillow-bar-shop.myshopify.com/collections/gifts/products/gift-card?variant=" + numbers);
      
    } else {
      console.error('Product not found.');
    }
  })
  .catch(function(error) {
    console.error('Error fetching product data:', error);
  });
}

/*============================================================================
  PRODUCT THUMBNAILS - PREV/NEXT ARROWS
==============================================================================*/
function initProductThumbArrows() {
  document.querySelectorAll('[data-product-thumbs]').forEach(function (wrap) {
    var scroller = wrap.querySelector('[data-product-thumbs-scroller]');
    var prevBtn = wrap.querySelector('[data-thumbs-arrow="prev"]');
    var nextBtn = wrap.querySelector('[data-thumbs-arrow="next"]');

    if (!scroller || (!prevBtn && !nextBtn)) {
      return;
    }

    if (prevBtn && !prevBtn.dataset.thumbsArrowBound) {
      prevBtn.dataset.thumbsArrowBound = 'true';
      prevBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn && !nextBtn.dataset.thumbsArrowBound) {
      nextBtn.dataset.thumbsArrowBound = 'true';
      nextBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' });
      });
    }
  });
}

document.addEventListener('page:loaded', initProductThumbArrows);

/*============================================================================
  QUANTITY STEPPER - +/- buttons around .product__quantity's number input
==============================================================================*/
function initQuantityStepper() {
  document.querySelectorAll('.product__quantity-stepper').forEach(function(stepper) {
    var input = stepper.querySelector('input[type=number]');
    var minusBtn = stepper.querySelector('[data-quantity-minus]');
    var plusBtn = stepper.querySelector('[data-quantity-plus]');
    if (!input || (!minusBtn && !plusBtn)) {
      return;
    }

    function step(delta) {
      var min = input.min !== '' ? parseInt(input.min, 10) : 1;
      var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) {
        current = min;
      }
      var next = Math.min(max, Math.max(min, current + delta));
      if (next === current) {
        return;
      }
      input.value = next;
      // other listeners (cart quantity sync, etc.) expect these DOM events,
      // not just the value changing
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minusBtn && !minusBtn.dataset.quantityBound) {
      minusBtn.dataset.quantityBound = 'true';
      minusBtn.addEventListener('click', function() {
        step(-1);
      });
    }

    if (plusBtn && !plusBtn.dataset.quantityBound) {
      plusBtn.dataset.quantityBound = 'true';
      plusBtn.addEventListener('click', function() {
        step(1);
      });
    }
  });
}

document.addEventListener('page:loaded', initQuantityStepper);

/*============================================================================
  CHECKBOX AGREEMENT - optional product block (product-template.liquid,
  'checkbox_agreement' case) whose checkbox gates the Add to Cart button
==============================================================================*/
function initCheckboxAddToCartGate() {
  document.querySelectorAll('[data-add-to-cart-gate]').forEach(function(checkbox) {
    if (checkbox.dataset.gateBound) {
      return;
    }
    var productSection = checkbox.closest('.product-section');
    var form = productSection ? productSection.querySelector('form[id^="AddToCartForm-"]') : null;
    if (!form) {
      return;
    }
    checkbox.dataset.gateBound = 'true';

    // the real blocker: some third-party script (nothing in our own theme
    // files — confirmed by grepping the whole repo) actively manages the
    // visible Add to Cart button after page load — it duplicates the
    // form's real submit button into a second hidden one carrying
    // data-add-to-cart, while the actual VISIBLE button loses that
    // attribute and gets reprocessed later (loading-spinner classes like
    // ld-over-inverse/running). Confirmed the button click never even
    // reaches a native form submit event, meaning something intercepts
    // the click directly and submits via its own AJAX call before our
    // form-level 'submit' listener would ever fire.
    //
    // A capturing-phase click listener on the form runs before ANY
    // listener attached directly to the button (capturing goes root ->
    // target, ahead of the target's own bubbling-phase listeners,
    // regardless of attachment order) — so this intercepts the click
    // itself, before that other script's own handler gets a chance to
    // run its AJAX submission. stopImmediatePropagation additionally
    // blocks every other click listener on the button, not just the
    // default action.
    form.addEventListener('click', function(event) {
      var target = event.target.closest('[data-add-to-cart], .add-to-cart, button[type="submit"], input[type="submit"]');
      if (target && !checkbox.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        checkbox.focus();
      }
    }, true);

    // belt-and-suspenders: also block native form submission directly,
    // in case something still reaches it by a path other than a click on
    // the button itself (e.g. pressing Enter in a field)
    form.addEventListener('submit', function(event) {
      if (!checkbox.checked) {
        event.preventDefault();
        checkbox.focus();
      }
    });

    // best-effort visual state on the visible button — a nice-to-have,
    // not the actual blocking mechanism, since it can be reset later
    function syncButtonAppearance() {
      var candidates = form.querySelectorAll('[data-add-to-cart], .add-to-cart');
      Array.prototype.forEach.call(candidates, function(button) {
        if (!button.classList.contains('hidden-cart-btn')) {
          button.disabled = !checkbox.checked;
        }
      });

      // #customily-cart-btn is Customily's own add-to-cart trigger,
      // rendered in its own modal/widget outside this form entirely — it
      // can go stale/get replaced by Customily's own re-renders (see the
      // staleness notes on initCustomilyTabs below), so this is looked up
      // fresh on every sync rather than cached
      var customilyBtn = document.getElementById('customily-cart-btn');
      if (customilyBtn) {
        customilyBtn.disabled = !checkbox.checked;
      }
    }

    // click-blocking safeguard for #customily-cart-btn, same rationale as
    // the form-level one above — being outside the form, it needs its own
    // listener rather than relying on the form's click capture
    document.addEventListener('click', function(event) {
      var target = event.target.closest('#customily-cart-btn');
      if (target && !checkbox.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        checkbox.focus();
      }
    }, true);

    checkbox.addEventListener('change', syncButtonAppearance);
    syncButtonAppearance();

    // #customily-cart-btn's modal only mounts once the shopper picks a
    // personalization option, so it doesn't exist yet at this point — the
    // syncButtonAppearance() call above found nothing to disable. Catch
    // its first appearance and apply the current checkbox state then;
    // the click-blocker above is the actual functional safeguard in the
    // meantime regardless, and disconnects itself once found rather than
    // running for the rest of the page's life
    if (!document.getElementById('customily-cart-btn')) {
      var customilyBtnWatcher = new MutationObserver(function() {
        if (document.getElementById('customily-cart-btn')) {
          syncButtonAppearance();
          customilyBtnWatcher.disconnect();
        }
      });
      customilyBtnWatcher.observe(document.body, { childList: true, subtree: true });
    }
  });
}

document.addEventListener('page:loaded', initCheckboxAddToCartGate);

/*============================================================================
  CUSTOMILY OPTIONS - top tab bar instead of the app's native accordion

  #cl_optionsapp is rendered by the third-party Customily app (Vue), so we
  never touch its own open/close state or pricing logic directly — this
  only builds a new tab bar on top and proxies clicks to Customily's own
  per-option trigger <label role="button">, then hides whichever option
  panels aren't the currently-open one. Customily keeps tracking its own
  state via aria-expanded exactly as before; we just watch that attribute
  to know what to show/hide and which tab to mark active.
==============================================================================*/
function initCustomilyTabs() {
  function setUpContainer(container) {
    if (container.dataset.tabsWatched) {
      return;
    }
    container.dataset.tabsWatched = 'true';

    // Customily periodically replaces a primary option's entire DOM subtree
    // with a fresh one (e.g. to recompute whether Color/Placement are
    // required, right after a monogram style is picked) — confirmed live:
    // a node captured at buildTabs() time later has isConnected === false,
    // replaced by an equivalent-looking live node we never learned about.
    // Any code that holds onto a specific .customily_option/label element
    // instead of looking it up fresh is one Customily-side re-render away
    // from silently acting on a detached node.
    //
    // Neither opt-id nor a CSS role class is a reliable identifier either:
    // switching styles can swap in a different Color option definition
    // entirely (different opt-id), and some styles add a SECOND option
    // sharing the exact same role class as the first (e.g. two options
    // both classed "color-options" — one for the letters, and depending on
    // style, a second color field whose own displayed name varies by
    // style). What's stable at any given moment is each option's displayed
    // NAME text, so primary options are tracked by name, and every action
    // (click, position, sync) looks the live node up fresh by name right
    // before using it.
    //
    // The SET of primary options isn't fixed either — a style that adds
    // that second color-style option changes the tab count. So buildTabs()
    // re-compares against the live DOM on every relevant mutation and
    // tears down + rebuilds the tab bar whenever the set of names actually
    // differs from what's currently built.
    function getOptionName(option) {
      var nameEl = option.querySelector('.option_name');
      var trigger = option.querySelector('label[role="button"]');
      return (nameEl ? nameEl.textContent : (trigger ? trigger.textContent : ''))
        .replace(/\*\s*Required/i, '').trim();
    }

    var primaryOptionNames = [];

    function getLiveOption(name) {
      var all = container.querySelectorAll('.customily_option');
      for (var i = 0; i < all.length; i++) {
        if (getOptionName(all[i]) === name) {
          return all[i];
        }
      }
      return null;
    }

    function getLiveTrigger(name) {
      var option = getLiveOption(name);
      return option ? option.querySelector('label[role="button"]') : null;
    }

    function isOptionExpanded(name) {
      var trigger = getLiveTrigger(name);
      return !!trigger && trigger.getAttribute('aria-expanded') === 'true';
    }

    // clicking Next/Back/a tab right as Customily is mid-reload for a style
    // change can land in the narrow window where the target option has been
    // torn down but its replacement hasn't been added back yet — getLiveTrigger
    // finds nothing at that exact instant even though it exists moments
    // later. Rather than silently dropping the click, keep looking for up
    // to 3s (Customily's own reload is a real network round-trip) before
    // giving up.
    function clickLiveTriggerWhenReady(name, deadline) {
      var trigger = getLiveTrigger(name);
      if (trigger) {
        trigger.click();
        return;
      }
      if (Date.now() < deadline) {
        setTimeout(function() { clickLiveTriggerWhenReady(name, deadline); }, 100);
      }
    }

    // .float-left / .float-left-single options are extra fields Customily
    // reveals dynamically (e.g. once a monogram style is chosen), added
    // to the DOM after buildTabs() already ran once. They don't get their
    // own tab — they belong to the first (Monogram Style) tab and should
    // only be visible while that one is active.
    //
    // Customily also reuses float-left/float-left-single as a general
    // layout class — e.g. a primary option can pick up float-left once a
    // monogram style is chosen. So "secondary" can't be determined by
    // class name alone at sync time, or an already-tabbed primary option
    // would get force-hidden the moment it gains that class, even though
    // its own tab is still meant to be clickable. Primary options are
    // excluded by name instead, so nothing already given a tab can ever be
    // reclassified as secondary later.
    function isSecondaryOption(option) {
      return (option.classList.contains('float-left') || option.classList.contains('float-left-single'))
        && primaryOptionNames.indexOf(getOptionName(option)) === -1;
    }

    function syncSecondaryOptions() {
      var isFirstActive = primaryOptionNames.length > 0 && isOptionExpanded(primaryOptionNames[0]);
      var shouldHide = !isFirstActive || needsFreshStyleChoice;
      Array.prototype.slice.call(container.querySelectorAll('.customily_option.float-left, .customily_option.float-left-single'))
        .filter(function(el) { return primaryOptionNames.indexOf(getOptionName(el)) === -1; })
        .forEach(function(secondary) {
          secondary.classList.toggle('customily-tab-hidden', shouldHide);
        });

      // the first primary option's nav row lives at container level (see
      // positionNavRow below) rather than nested in its own content, so it
      // no longer gets hidden automatically when that tab collapses — keep
      // it in sync with its secondary options, which share the same rule
      var externalNavRow = container.querySelector('.customily-nav-buttons.customily-nav-external');
      if (externalNavRow) {
        externalNavRow.classList.toggle('customily-tab-hidden', !isFirstActive);
      }
    }

    // Each tab's Next button is disabled until every field currently
    // visible on that tab has a value - "currently visible" matters most
    // on Monogram Style, where a style like Lotus reveals an arrangement
    // dropdown that in turn reveals 1-3 text inputs depending on what's
    // picked; only the ones actually shown need to be filled, and the
    // set can change as the shopper picks a different arrangement.
    // offsetParent !== null is used throughout as the visibility check
    // (matches every other visibility check in this file - reliable
    // whether an element is hidden via customily-tab-hidden, a collapsed
    // sub-accordion, or Customily's own display:none) rather than trying
    // to enumerate every way a field can be hidden.
    function isFieldVisible(el) {
      return el.offsetParent !== null;
    }

    function isFieldFilled(el) {
      var tag = el.tagName;
      if (tag === 'SELECT') {
        return el.value !== '';
      }
      if (tag === 'TEXTAREA' || tag === 'INPUT') {
        var type = (el.type || 'text').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          return el.checked;
        }
        if (type === 'button' || type === 'submit' || type === 'hidden') {
          return true;
        }
        return el.value.trim() !== '';
      }
      return true;
    }

    // true only if every visible, enabled field within scopeEl has a
    // value - radio groups are resolved once per name (not once per
    // radio) since only one member of the group needs to be checked
    function scopeIsComplete(scopeEl) {
      if (!scopeEl) {
        return true;
      }
      var controls = scopeEl.querySelectorAll('input, select, textarea');
      var resolvedRadioGroups = {};
      for (var i = 0; i < controls.length; i++) {
        var el = controls[i];
        if (el.disabled) {
          continue;
        }
        if (el.tagName === 'INPUT' && el.type === 'radio') {
          if (resolvedRadioGroups[el.name] !== undefined) {
            continue;
          }
          resolvedRadioGroups[el.name] = true;
          // the native radio input in a swatch/style picker is commonly
          // hidden behind a custom-styled <label> standing in for it -
          // confirmed live: offsetParent is null on every radio in the
          // Monogram Style grid, always, checked or not - so a group's
          // visibility has to be judged by whether any of ITS LABELS are
          // visible, not the (always-hidden) inputs themselves
          var groupRadios = scopeEl.querySelectorAll('input[type="radio"][name="' + el.name + '"]');
          var groupVisible = false;
          for (var g = 0; g < groupRadios.length; g++) {
            var radio = groupRadios[g];
            var label = radio.id ? scopeEl.querySelector('label[for="' + radio.id + '"]') : null;
            if (isFieldVisible(radio) || (label && isFieldVisible(label))) {
              groupVisible = true;
              break;
            }
          }
          if (!groupVisible) {
            continue;
          }
          if (!scopeEl.querySelector('input[type="radio"][name="' + el.name + '"]:checked')) {
            return false;
          }
          continue;
        }
        if (!isFieldVisible(el)) {
          continue;
        }
        if (!isFieldFilled(el)) {
          return false;
        }
      }
      return true;
    }

    // Monogram Style (index 0) is the one primary option whose secondary
    // (float-left/float-left-single) fields live as siblings at container
    // level rather than nested in its own .cl-option-content - see the
    // staleness note above isSecondaryOption - so completeness for that
    // tab has to separately check every currently-visible secondary too.
    function panelIsComplete(option, index) {
      var content = option.querySelector('.cl-option-content');
      if (!scopeIsComplete(content)) {
        return false;
      }
      if (index !== 0) {
        return true;
      }
      var secondaries = container.querySelectorAll('.customily_option.float-left, .customily_option.float-left-single');
      for (var i = 0; i < secondaries.length; i++) {
        var secondary = secondaries[i];
        if (primaryOptionNames.indexOf(getOptionName(secondary)) !== -1 || !isFieldVisible(secondary)) {
          continue;
        }
        var secondaryContent = secondary.querySelector('.cl-option-content') || secondary;
        if (!scopeIsComplete(secondaryContent)) {
          return false;
        }
      }
      return true;
    }

    function updateAllNextButtonsState() {
      primaryOptionNames.forEach(function(name, index) {
        if (index === primaryOptionNames.length - 1) {
          return;
        }
        var option = getLiveOption(name);
        if (!option) {
          return;
        }
        var navRow = container.querySelector('.customily-nav-buttons[data-nav-index="' + index + '"]');
        var nextBtn = navRow ? navRow.querySelector('.customily-next-btn:not(.customily-save-spacer)') : null;
        if (!nextBtn) {
          return;
        }
        nextBtn.disabled = !panelIsComplete(option, index);
      });
    }

    // positions a primary option's Back/Next row. For every option except
    // the first, that's simply inside its own content, right above
    // p.small_text ("Please note..." disclaimer) if it has one, falling back
    // to .help-text, otherwise at the end of the panel.
    //
    // The first (Monogram Style) option is different: its float-left /
    // float-left-single secondary options render as siblings of
    // .customily_option in the container, not nested inside this option's
    // own content, so the nav row is moved out to container level too,
    // positioned right after the last secondary option, so it always
    // appears below them rather than above.
    //
    // Customily renders content asynchronously — secondaries in particular
    // can appear after the row was first built — so this gets called again
    // on every subsequent container mutation to keep the row correctly
    // placed as the DOM changes. Moving a node with insertBefore/appendChild
    // is itself a childList mutation even when it doesn't change the node's
    // actual position, which would re-trigger the very watcher that calls
    // this — so every branch checks the current position first and only
    // moves the row when it's actually out of place, to avoid an infinite
    // mutation loop.
    // `force` bypasses the "don't move while open" guard below — used only
    // at the moment a panel opens, to catch its nav row up to wherever its
    // secondary options currently are before the user can click anything.
    function positionNavRow(option, index, navRow, force) {
      if (index !== 0) {
        var content = option.querySelector('.cl-option-content');
        var smallText = content.querySelector('p.small_text');
        var helpText = content.querySelector('.help-text');

        if (smallText) {
          // buttons sit above the disclaimer. Comparing element-only
          // siblings (not nextSibling/previousSibling) so a whitespace text
          // node between them doesn't make this look "out of place" forever
          // — that would re-trigger insertBefore, and thus the mutation
          // watcher that calls this, on every tick: an infinite loop.
          if (navRow.nextElementSibling !== smallText) {
            content.insertBefore(navRow, smallText);
          }
        } else if (helpText) {
          // .help-text (e.g. on the Placement screen) sits above the
          // buttons instead — the reverse of p.small_text
          if (navRow.previousElementSibling !== helpText) {
            content.insertBefore(navRow, helpText.nextSibling);
          }
        } else if (navRow.parentNode !== content || content.lastElementChild !== navRow) {
          content.appendChild(navRow);
        }
        return;
      }

      // Switching monogram styles reloads that option's fields from the
      // server (a real network round-trip — see "Loading product..." in
      // Customily's own console logs), which can take a while. If the panel
      // is open and the user could be clicking Next/Back right now, moving
      // this button out from under their cursor mid-click makes the click
      // land on empty space — it silently "doesn't respond". So while the
      // panel is open, hold position steady; only catch up when it opens
      // (force === true, called from syncActiveState below), before the
      // user has had a chance to click anything in it yet.
      var isOpen = primaryOptionNames.length > 0 && isOptionExpanded(primaryOptionNames[0]);
      if (isOpen && !force) {
        return;
      }

      var secondaries = Array.prototype.slice.call(container.querySelectorAll('.customily_option.float-left, .customily_option.float-left-single'))
        .filter(function(el) { return primaryOptionNames.indexOf(getOptionName(el)) === -1; });
      var afterEl = secondaries.length ? secondaries[secondaries.length - 1] : option;
      var optionsParent = afterEl.parentNode;
      if (optionsParent && navRow.previousElementSibling !== afterEl) {
        optionsParent.insertBefore(navRow, afterEl.nextSibling);
      }
    }

    // `option` must be the current live node (looked up via getLiveOption),
    // never a cached reference — see the staleness note above isSecondaryOption.
    //
    // Customily's own Save button (#customily-save-button, normally in its
    // right-hand preview panel) visually appears next to Back on the final
    // tab. CONFIRMED BY LIVE BISECTION TESTING (not just theory): actually
    // moving that button's real DOM node via appendChild() - even deferred
    // to the next animation frame to avoid racing Vue's own render cycle -
    // corrupts something in Customily's own internal state in a way that
    // later surfaces as their own upsell logic misfiring an unwanted add-to-
    // cart. A build with this relocation reduced to a no-op (button left
    // untouched in its native location) did not reproduce the bug; the same
    // build with the DOM move restored did. So the real node is never moved
    // now - only visually repositioned with fixed positioning, computed
    // from the nav row's live on-screen position, updated on every scroll
    // (captured so it catches the accordion's own internal scrolling, which
    // doesn't bubble) and resize.
    var saveButtonPositionTarget = null;
    var positionMutationObserverAttached = false;

    // Customily's own accordion panel scrolls internally in a short pane
    // of its own (confirmed live on mobile: .dotted-border-right, ~291px
    // tall) whose scrollHeight comes from a third-party resize-sensor that
    // doesn't appear to notice our own injected nav row - confirmed live:
    // even scrolled to its own reported maximum, that pane's content still
    // fell short of actually bringing navRow into view. That makes "is
    // navRow currently visible" unreliable to check directly, and trying
    // to detect overlap against one specific element (.customily-right-
    // panel, the Monogram Preview column) wasn't reliable either - the
    // mismatch can land the button somewhere else entirely (confirmed
    // live: also seen sitting near the header, above the accordion, not
    // overlapping that panel at all). Simpler and more robust: once the
    // button would land past the vertical midpoint of #cl_optionsapp
    // (Customily's own outermost container for this whole popup), hide it
    // outright rather than trying to identify every element it might be
    // sitting on top of down there.
    function updateSaveButtonPosition() {
      if (!saveButtonPositionTarget) {
        return;
      }
      var saveBtn = document.getElementById('customily-save-button');
      var navRow = saveButtonPositionTarget;
      if (!saveBtn || !document.body.contains(navRow) || navRow.offsetParent === null) {
        // offsetParent is null when the row (or an ancestor) is
        // display:none - e.g. a different tab is active. Once
        // relocateSaveButton() has taken ownership of this button (see
        // there), removing just the positioned class isn't enough - that
        // only stops moving it, it doesn't hide it, so it falls back to
        // sitting wherever Customily natively renders it (next to Cancel
        // in the preview panel), visible on every tab but the final one -
        // confirmed live after clicking Back. Hide it outright instead.
        if (saveBtn) {
          saveBtn.classList.remove('customily-save-button--positioned');
          saveBtn.classList.add('customily-save-button--hidden');
        }
        return;
      }
      saveBtn.classList.remove('customily-save-button--hidden');
      saveBtn.classList.add('customily-save-button--positioned');
      var rect = navRow.getBoundingClientRect();
      // .customily-save-spacer (see ensureNavButtons) is an invisible
      // placeholder occupying Save's spot in the row's real flex layout,
      // so the row's own justify-content:center centers Back+spacer as a
      // pair - the same way Back+Next centers on every other tab. Save
      // itself is never a real flex child (still never moved into the
      // DOM - see the block comment above), just visually overlaid
      // exactly on top of the spacer's rect via position:fixed.
      var spacer = navRow.querySelector('.customily-save-spacer');
      var spacerRect = spacer ? spacer.getBoundingClientRect() : null;
      var desiredTop = rect.top;
      var desiredLeft = spacerRect ? spacerRect.left : rect.left;
      saveBtn.style.top = desiredTop + 'px';
      saveBtn.style.left = desiredLeft + 'px';
      // position:fixed takes it out of the row's flex layout, so it no
      // longer inherits a width from flex - match it to the spacer it's
      // standing in for instead
      if (spacerRect) {
        saveBtn.style.width = spacerRect.width + 'px';
        // Customily's own button styling gives #customily-save-button a
        // shorter height than Back/Next (confirmed live: ~4px shorter) -
        // match it to the spacer's height too, so Save reads as the same
        // size as Back, not just the same width.
        saveBtn.style.height = spacerRect.height + 'px';
      }

      // position:fixed is normally viewport-relative, but Customily's own
      // modal wraps its content in an ancestor with a transform (confirmed
      // live: the button consistently landed ~56px below the coordinates
      // set here) - which per spec makes THAT ancestor the containing block
      // for fixed descendants instead of the viewport, silently offsetting
      // naive viewport-relative coordinates. Rather than hunting for which
      // ancestor is responsible (fragile - Customily's own markup, not
      // ours), self-correct: place the button, measure where it actually
      // landed, and solve for the one-shot correction that cancels the
      // ancestor's constant offset.
      var actual = saveBtn.getBoundingClientRect();
      var deltaTop = desiredTop - actual.top;
      var deltaLeft = desiredLeft - actual.left;
      if (deltaTop || deltaLeft) {
        saveBtn.style.top = (desiredTop + deltaTop) + 'px';
        saveBtn.style.left = (desiredLeft + deltaLeft) + 'px';
      }

      // Mobile only (same breakpoint setPanels() above already uses) -
      // on desktop the accordion and Monogram Preview sit in separate
      // side-by-side columns, both roughly full height, so a Back/Save
      // row legitimately near the bottom of a tall accordion can be past
      // the container's own vertical midpoint without anything having
      // gone wrong. On mobile, where the accordion stacks above the
      // Preview column instead, past halfway down #cl_optionsapp (
      // Customily's own outermost container for this whole popup) means
      // the button is no longer anywhere near an accordion nav row - hide
      // it rather than let it sit wherever the mismatch landed it.
      if (window.innerWidth < 768) {
        var optionsApp = document.getElementById('cl_optionsapp');
        if (optionsApp) {
          var appRect = optionsApp.getBoundingClientRect();
          var midpoint = appRect.top + (appRect.height / 2);
          var finalRect = saveBtn.getBoundingClientRect();
          if (finalRect.top > midpoint) {
            saveBtn.classList.remove('customily-save-button--positioned');
            saveBtn.classList.add('customily-save-button--hidden');
          }
        }
      }
    }

    function relocateSaveButton(navRow) {
      var saveBtn = document.getElementById('customily-save-button');
      if (!saveBtn) {
        return;
      }
      saveButtonPositionTarget = navRow;
      updateSaveButtonPosition();

      // Customily animates the accordion panel's own expand/collapse (a
      // CSS transition, not a scroll) when switching tabs - confirmed
      // live on a product with 3+ tabs (bath-mat's First/Second Letter
      // Color): the button froze at the position measured the instant
      // the tab switched, before that transition settled, landing well
      // below Back's actual final position once it did. Neither the
      // scroll nor resize listener below fires for a pure CSS transition,
      // so re-run the position calc every frame for a short window after
      // every relocation to track the row through it.
      var settleUntil = Date.now() + 600;
      (function settle() {
        updateSaveButtonPosition();
        if (Date.now() < settleUntil) {
          window.requestAnimationFrame(settle);
        }
      })();

      if (!window.customilySavePositionListenersAttached) {
        window.customilySavePositionListenersAttached = true;
        // capture:true - scroll events don't bubble, but a capturing
        // listener still sees them fire on the way down to their target,
        // which is how this catches the accordion's own internal scrolling
        window.addEventListener('scroll', updateSaveButtonPosition, true);
        window.addEventListener('resize', updateSaveButtonPosition);
      }

      if (!positionMutationObserverAttached) {
        positionMutationObserverAttached = true;
        // The settle loop above only covers a tab SWITCH's own transition.
        // Picking a color swatch on the tab that's already active can also
        // shift this row's position - e.g. Customily toggling helper text
        // in/out, or re-rendering the preview - without any tab switch,
        // scroll, or resize firing to tell us. Re-run the position calc on
        // any DOM change instead of guessing which ones matter;
        // rAF-debounced since a single interaction can produce a burst of
        // mutations and the calc only needs to run once per frame, not
        // once per mutation.
        //
        var positionMutationScheduled = false;
        function schedulePositionUpdate() {
          if (positionMutationScheduled) {
            return;
          }
          positionMutationScheduled = true;
          window.requestAnimationFrame(function() {
            positionMutationScheduled = false;
            updateSaveButtonPosition();
          });
        }
        var positionMutationObserver = new MutationObserver(schedulePositionUpdate);
        positionMutationObserver.observe(container, { childList: true, subtree: true, attributes: true, characterData: true });

        // #customily-save-button going from disabled to enabled (e.g.
        // right as the last required selection is made) can also shift
        // where it needs to sit, without any accordion-side mutation to
        // tell us - it lives in Customily's own right-hand preview panel,
        // outside the accordion entirely, so the observer above never
        // sees it. Watching the button directly closes that gap, but
        // ONLY for its disabled attribute - NOT style/class, which is
        // exactly what updateSaveButtonPosition() itself writes on every
        // call. Watching those too would make this observer retrigger
        // itself from its own writes, forever, once per frame - confirmed
        // live: caused continuous jitter while hovering, each frame's
        // self-correction (see there) chasing the rendered position the
        // previous frame's own write had just produced.
        var saveButtonAttrObserver = new MutationObserver(schedulePositionUpdate);
        saveButtonAttrObserver.observe(saveBtn, { attributes: true, attributeFilter: ['disabled'] });
      }
    }

    function restoreSaveButton() {
      saveButtonPositionTarget = null;
      var saveBtn = document.getElementById('customily-save-button');
      if (saveBtn) {
        saveBtn.classList.remove('customily-save-button--positioned');
        saveBtn.classList.remove('customily-save-button--hidden');
      }
    }

    // mirrors the tab's own label at the top of its content panel — looked
    // up/re-checked fresh every call rather than flagged-once, since
    // .cl-option-content (and everything inside it) can be replaced
    // wholesale by Customily's own re-renders, same as everything else here
    function ensureOptionHeading(option, name) {
      var content = option.querySelector('.cl-option-content');
      if (!content) {
        return;
      }

      var heading = content.querySelector('.customily-panel-heading');
      if (heading) {
        if (heading.textContent !== name) {
          heading.textContent = name;
        }
        return;
      }

      heading = document.createElement('h3');
      heading.className = 'small customily-panel-heading';
      heading.textContent = name;
      content.insertBefore(heading, content.firstChild);
    }

    // Every color screen (Color, First Letter Color, Second Letter Color,
    // etc. - all share the "color-options" role class, see the note above
    // getOptionName) shows the chosen swatch's value right next to its
    // heading once one is picked, and removes it again if nothing is
    // chosen - looked up fresh every call, same as everything else here,
    // since Customily can replace this content wholesale between calls.
    function updateColorValueDisplays() {
      var colorOptions = container.querySelectorAll('.customily_option.color-options');
      Array.prototype.forEach.call(colorOptions, function(option) {
        var content = option.querySelector('.cl-option-content');
        var heading = content && content.querySelector('.customily-panel-heading');
        if (!heading) {
          return;
        }

        var checked = content.querySelector('input[type="radio"]:checked');
        var value = checked ? checked.value : '';

        var valueEl = heading.nextElementSibling;
        var hasValueEl = valueEl && valueEl.classList.contains('customily-color-value');

        if (!value) {
          if (hasValueEl) {
            valueEl.remove();
          }
          return;
        }

        if (!hasValueEl) {
          valueEl = document.createElement('span');
          valueEl.className = 'customily-color-value';
          heading.parentNode.insertBefore(valueEl, heading.nextSibling);
        }

        if (valueEl.textContent !== value) {
          valueEl.textContent = value;
        }
      });
    }

    function ensureNavButtons(option, index, force) {
      var content = option.querySelector('.cl-option-content');
      if (!content) {
        return;
      }

      if (option.dataset.navBuilt) {
        var existingRow = container.querySelector('.customily-nav-buttons[data-nav-index="' + index + '"]');
        if (existingRow) {
          // positionNavRow first - it may move existingRow itself, and
          // relocateSaveButton now only visually tracks that row's
          // position rather than moving anything, so it needs to run
          // after the row has settled into its final spot
          positionNavRow(option, index, existingRow, force);
          if (index === primaryOptionNames.length - 1) {
            existingRow.classList.add('customily-nav-final');
            relocateSaveButton(existingRow);
          }
        }
        return;
      }

      // Customily can replace a primary option's entire DOM subtree with a
      // fresh node (see the staleness note above isSecondaryOption) while
      // leaving that option's OWN nav row untouched, since the row itself
      // was never part of the subtree that got swapped (for index 0 it's a
      // container-level sibling; for others it's nested inside content that
      // may or may not have been replaced along with it). The new option
      // node has no navBuilt flag of its own, so without this it gets a
      // brand new row built right alongside the still-present old one -
      // producing the duplicate Back/Next buttons this was built to catch.
      var staleRow = container.querySelector('.customily-nav-buttons[data-nav-index="' + index + '"]');
      if (staleRow && staleRow.parentNode) {
        staleRow.parentNode.removeChild(staleRow);
      }

      option.dataset.navBuilt = 'true';

      var navRow = document.createElement('div');
      navRow.className = 'customily-nav-buttons';
      navRow.dataset.navIndex = String(index);
      if (index === 0) {
        navRow.classList.add('customily-nav-external');
      }
      if (index === primaryOptionNames.length - 1) {
        navRow.classList.add('customily-nav-final');
      }

      if (index > 0) {
        var backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'customily-back-btn';
        backBtn.textContent = 'Back';
        backBtn.addEventListener('click', function() {
          clickLiveTriggerWhenReady(primaryOptionNames[index - 1], Date.now() + 3000);
        });
        navRow.appendChild(backBtn);
      }

      if (index === primaryOptionNames.length - 1) {
        // #customily-save-button is never a real child of this row (see
        // relocateSaveButton) - it's only visually overlaid on top of this
        // spacer via position:fixed. Without something real occupying its
        // spot, the row's justify-content:center would center Back ALONE,
        // leaving the Back+Save pair looking left-shifted instead of
        // centered as a pair. Sized identically to Back/Next (same class)
        // so centering Back+spacer reproduces the same centered look
        // Back+Next already has on every other tab.
        var saveSpacer = document.createElement('span');
        saveSpacer.className = 'customily-next-btn customily-save-spacer';
        saveSpacer.setAttribute('aria-hidden', 'true');
        navRow.appendChild(saveSpacer);
      }

      if (index < primaryOptionNames.length - 1) {
        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'customily-next-btn';
        nextBtn.textContent = 'Next';
        // safe default until updateAllNextButtonsState() (called at the
        // end of syncAllTabStates(), which always runs after this
        // synchronously within the same buildTabs() pass) has a chance
        // to compute the real state from this tab's actual fields
        nextBtn.disabled = true;
        nextBtn.addEventListener('click', function() {
          clickLiveTriggerWhenReady(primaryOptionNames[index + 1], Date.now() + 3000);
        });
        navRow.appendChild(nextBtn);
      }

      positionNavRow(option, index, navRow, true);

      if (index === primaryOptionNames.length - 1) {
        relocateSaveButton(navRow);
      }
    }

    // name -> tabButton, so syncAllTabStates() can update visuals without
    // holding onto any option/trigger/content element reference
    var tabButtonsByName = {};
    var tabBarEl = null;
    var activeStateWatcherAttached = false;
    var cancelResetListenerAttached = false;
    var nextButtonValidationListenerAttached = false;

    // Customily reveals a style's secondary fields (arrangement dropdown,
    // per-letter color/text inputs - the .float-left/.float-left-single
    // options handled below) once a style is picked, and doesn't hide
    // them again just because the popup was closed - its own internal
    // "a style is selected" state isn't reset by Cancel any more than the
    // active tab is. Set on Cancel, cleared the moment the shopper clicks
    // a style swatch again; syncSecondaryOptions() below force-hides
    // secondaries while this is true, regardless of whether Monogram
    // Style is the active tab (which alone isn't enough post-cancel, per
    // the screenshot that motivated this - secondaries stayed visible
    // even after the active-tab reset already worked).
    var needsFreshStyleChoice = false;

    // re-derives every tab's active/hidden state and nav-row placement by
    // looking each primary option up fresh (by name) rather than trusting
    // any previously-captured element — see the staleness note above
    // isSecondaryOption. Driven by a single container-level attribute
    // observer (below) instead of one MutationObserver per trigger, so it
    // keeps working even after Customily replaces a trigger's DOM node.
    function syncAllTabStates() {
      primaryOptionNames.forEach(function(name, index) {
        var option = getLiveOption(name);
        var tabButton = tabButtonsByName[name];
        if (!option || !tabButton) {
          return;
        }
        var expanded = isOptionExpanded(name);
        tabButton.classList.toggle('active', expanded);
        option.classList.toggle('customily-tab-hidden', !expanded);
        if (expanded) {
          // catch this option's nav row up to its current secondary
          // options right as the panel opens, before the user has had a
          // chance to click anything in it — positionNavRow otherwise
          // holds position steady while a panel is open (see there for why)
          ensureNavButtons(option, index, true);
          ensureOptionHeading(option, name);
        }
      });
      syncSecondaryOptions();
      updateAllNextButtonsState();
      updateColorValueDisplays();
      // A pure CSS transition (Customily's own modal-open/tab-switch
      // animation - see the settle loop in relocateSaveButton for the
      // same issue and why it needs this, not just a MutationObserver)
      // doesn't reliably fire a DOM mutation when it finishes, so a field
      // that's transiently offscreen/invisible during that animation can
      // get judged "not applicable yet" and never re-checked once it
      // settles. Re-run the check every frame for a short window after
      // every call to catch that settling regardless of what triggered it.
      var nextButtonSettleUntil = Date.now() + 600;
      (function settleNextButtons() {
        updateAllNextButtonsState();
        updateColorValueDisplays();
        if (Date.now() < nextButtonSettleUntil) {
          window.requestAnimationFrame(settleNextButtons);
        }
      })();
    }

    // Opens the first tab whenever nothing is currently expanded. Called
    // both after a genuine rebuild (buildTabs) and after every relevant
    // per-option mutation (the container-level watcher below) — Customily
    // can replace and re-collapse a SINGLE primary option's node (e.g.
    // Monogram Style) without changing the overall set of option names, so
    // buildTabs() alone never sees that as a "rebuild" and would otherwise
    // never notice the popup has gone fully collapsed.
    function reopenFirstTabIfNoneExpanded() {
      var anyExpanded = primaryOptionNames.some(isOptionExpanded);
      if (!anyExpanded && primaryOptionNames.length > 0) {
        clickLiveTriggerWhenReady(primaryOptionNames[0], Date.now() + 3000);
      }
    }

    // removes everything a previous buildTabs() created, so it can be
    // rebuilt cleanly when the set of primary options itself changes (e.g.
    // a monogram style that adds its own extra color-style option) —
    // without this, stale nav rows would keep pointing at the old tab
    // order, and dataset.navBuilt would block rebuilding them
    function teardownTabs() {
      // pull the real Save button back to its native location first — it's
      // about to have the nav row it's currently sitting in removed, and
      // removeChild takes descendants along with it
      restoreSaveButton();

      if (tabBarEl && tabBarEl.parentNode) {
        tabBarEl.parentNode.removeChild(tabBarEl);
      }
      tabBarEl = null;
      tabButtonsByName = {};
      Array.prototype.slice.call(container.querySelectorAll('.customily-nav-buttons')).forEach(function(row) {
        if (row.parentNode) {
          row.parentNode.removeChild(row);
        }
      });
      Array.prototype.slice.call(container.querySelectorAll('.customily_option')).forEach(function(option) {
        delete option.dataset.navBuilt;
      });
    }

    // builds the tab bar from the current live set of primary options, or
    // tears down and rebuilds it from scratch if that set has changed
    // since the last build (different names and/or a different count) —
    // e.g. a monogram style that adds its own extra color-style option
    function buildTabs() {
      var allOptions = Array.prototype.slice.call(container.querySelectorAll('.customily_option'));
      if (allOptions.length === 0) {
        return;
      }

      var primaryOptions = allOptions.filter(function(o) { return !isSecondaryOption(o); });
      if (primaryOptions.length === 0) {
        return;
      }

      var newNames = primaryOptions.map(getOptionName);
      var alreadyBuilt = container.dataset.tabsBuilt === 'true';
      var namesMatch = alreadyBuilt
        && newNames.length === primaryOptionNames.length
        && newNames.every(function(n, i) { return n === primaryOptionNames[i]; });

      if (alreadyBuilt && namesMatch) {
        return;
      }

      if (alreadyBuilt) {
        teardownTabs();
      }

      primaryOptionNames = newNames;
      container.dataset.tabsBuilt = 'true';

      var tabBar = document.createElement('div');
      tabBar.className = 'customily-tabs';
      tabBarEl = tabBar;

      primaryOptions.forEach(function(option, index) {
        var name = primaryOptionNames[index];
        var trigger = option.querySelector('label[role="button"]');
        if (!trigger) {
          return;
        }

        ensureNavButtons(option, index);
        ensureOptionHeading(option, name);

        var tabButton = document.createElement('button');
        tabButton.type = 'button';
        tabButton.className = 'customily-tab';

        var labelSpan = document.createElement('span');
        labelSpan.className = 'tab-label';
        labelSpan.textContent = name;
        tabButton.appendChild(labelSpan);

        if (index < primaryOptions.length - 1) {
          var divider = document.createElement('span');
          divider.className = 'divider';
          divider.textContent = '>';
          tabButton.appendChild(divider);
        }

        tabButton.addEventListener('click', function() {
          // let Customily's own trigger handle the actual open/close —
          // we don't reimplement its state. Looked up fresh (and retried
          // briefly if not found yet), in case this option's DOM has been
          // replaced or is mid-reload.
          clickLiveTriggerWhenReady(name, Date.now() + 3000);
        });

        tabBar.appendChild(tabButton);
        tabButtonsByName[name] = tabButton;
      });

      container.insertBefore(tabBar, container.firstChild);

      // a single subtree-wide attribute observer replaces one MutationObserver
      // per trigger — those would each go silent the moment Customily
      // replaced the specific node they were watching. Attached once and
      // left in place across rebuilds, since it only reads live state fresh.
      if (!activeStateWatcherAttached) {
        var activeStateWatcher = new MutationObserver(syncAllTabStates);
        activeStateWatcher.observe(container, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
        activeStateWatcherAttached = true;
      }

      if (!nextButtonValidationListenerAttached) {
        nextButtonValidationListenerAttached = true;
        // re-checks every tab's Next button on every keystroke/selection
        // change anywhere in the accordion - unlike Cancel/Save (which
        // live in Customily's separate preview panel), these fields
        // genuinely live inside container, so bubbling-phase + delegation
        // is enough here. rAF-debounced since typing fires 'input'
        // repeatedly and the check only needs to run once per frame.
        var nextButtonValidationScheduled = false;
        function scheduleNextButtonValidation() {
          if (nextButtonValidationScheduled) {
            return;
          }
          nextButtonValidationScheduled = true;
          window.requestAnimationFrame(function() {
            nextButtonValidationScheduled = false;
            updateAllNextButtonsState();
            updateColorValueDisplays();
          });
        }
        container.addEventListener('input', scheduleNextButtonValidation);
        container.addEventListener('change', scheduleNextButtonValidation);
        // swatch/style pickers here set the radio's checked property
        // directly from Vue's own reactive update rather than through a
        // real user interaction with the (hidden) input - confirmed live:
        // clicking a style swatch DOES end up with the right radio
        // .checked, but never fires a 'change' event, and never produces
        // a MutationObserver-visible attribute mutation either (checked
        // is an IDL property, decoupled from the reflected HTML
        // attribute, for checkbox/radio inputs specifically - the
        // observer below genuinely can't see this class of change). A
        // 'click' on the swatch/label itself still fires as a real DOM
        // event no matter what Vue does internally in response, so it's
        // the one reliable signal - rAF-debounced same as the others,
        // which also gives Vue's own (microtask-flushed) update time to
        // land before this re-checks.
        // capturing phase, not bubbling - confirmed live (same finding as
        // the Cancel-button listener above): a bubbling-phase click
        // listener here never saw a swatch click at all, meaning
        // Customily's own click handling on it stops the event from
        // bubbling any further
        container.addEventListener('click', scheduleNextButtonValidation, true);

        // 'input'/'change' alone miss one case: the very first check, run
        // synchronously while this tab's fields are still settling from
        // Customily's own modal-open animation. Confirmed live: at that
        // moment every swatch's offsetParent is still null (genuinely,
        // transiently invisible), so scopeIsComplete() correctly-in-
        // isolation treats the whole radio group as not-yet-applicable
        // and skips it - which makes an EMPTY selection look complete,
        // enabling Next before anything was chosen. Nothing then
        // re-validates once the animation finishes, since opening the
        // modal fires no 'input'/'change' of its own. A MutationObserver
        // on the same broad scope as the Save-button one above re-checks
        // on whatever DOM settling that animation itself produces.
        var nextButtonMutationObserver = new MutationObserver(scheduleNextButtonValidation);
        nextButtonMutationObserver.observe(container, { childList: true, subtree: true, attributes: true, characterData: true });
      }

      if (!cancelResetListenerAttached) {
        cancelResetListenerAttached = true;
        // Cancel closes the popup, but Customily's own accordion state
        // isn't torn down with it - the same container is reused next
        // time it opens, so without this it reopens wherever the wizard
        // was left (e.g. still on Color), not Monogram Style. Delegated
        // on document, NOT container - confirmed live: #customily-cancel-
        // button lives in Customily's own right-hand preview panel next
        // to Save, outside the accordion container entirely (the same
        // place #customily-save-button lives - see relocateSaveButton),
        // so a listener on container never saw its clicks bubble through.
        // Capturing phase (the `true` below), not bubbling - confirmed
        // live: a bubbling-phase listener here never saw the click at
        // all, while an identical capturing-phase one did every time,
        // meaning Customily's own click handling on this button stops the
        // event from bubbling any further (Vue's @click.stop is the usual
        // cause) - capturing fires on the way DOWN, ahead of that.
        // Clicking the Monogram Style tab's own trigger - rather than
        // setting aria-expanded ourselves - lets Customily's normal
        // one-tab-open-at-a-time accordion behavior collapse whichever
        // tab was open, which is what already keeps every OTHER tab's
        // selects/inputs hidden (.customily-tab-hidden, driven by
        // syncAllTabStates above) until the shopper reaches them - so
        // resetting the active tab alone is enough to hide them too, no
        // separate hide step needed. Works even while the popup is
        // already closing/hidden: .click() on a real (if invisible) DOM
        // node still fires Customily's own handler - EXCEPT synchronously,
        // from inside this same click event: confirmed live, calling
        // .click() on the Style tab's own trigger while Cancel's click is
        // still being dispatched silently did nothing (presumably Vue
        // ignoring/queuing it while mid-handling its own event), while
        // the identical call made a tick later worked every time. setTimeout
        // (even 0ms) is enough to get out from under the original event.
        document.addEventListener('click', function(event) {
          // #noMonogram (the "No Monogram" checkbox on the product page,
          // outside the popup entirely) should reset the popup exactly
          // like Cancel does - choosing No Monogram means whatever
          // monogram configuration was in progress no longer applies,
          // same as backing out of the popup does. Same capturing-phase
          // delegation as Cancel below, for the same reason: it lives
          // outside this container, and needs to work regardless of
          // whether the popup is even open right now.
          if (event.target.closest && (event.target.closest('#customily-cancel-button') || event.target.closest('#noMonogram'))) {
            needsFreshStyleChoice = true;
            window.setTimeout(function() {
              clickLiveTriggerWhenReady(primaryOptionNames[0], Date.now() + 5000);
              syncSecondaryOptions();
            }, 0);
          }
        }, true);

        // Clears needsFreshStyleChoice the moment the shopper actually
        // picks a style again - delegated on container (unlike Cancel,
        // the style swatches genuinely live inside the accordion) and
        // capturing-phase for the same reason established above. Scoped
        // to .cl-option-content specifically, NOT the whole option
        // element - confirmed live: the option's own accordion-header
        // trigger (a sibling of .cl-option-content, clicked by
        // clickLiveTriggerWhenReady above to reset the active tab) is
        // also technically "inside" the option element, so checking
        // against the whole option cleared this the instant Cancel ran,
        // before the shopper had picked anything.
        container.addEventListener('click', function(event) {
          if (!needsFreshStyleChoice) {
            return;
          }
          var firstOption = getLiveOption(primaryOptionNames[0]);
          var content = firstOption ? firstOption.querySelector('.cl-option-content') : null;
          if (content && content.contains(event.target)) {
            needsFreshStyleChoice = false;
            syncSecondaryOptions();
          }
        }, true);
      }

      syncAllTabStates();
      reopenFirstTabIfNoneExpanded();
    }

    // does this node (or one of its descendants) matter for tab/nav-row
    // rebuilding or placement? Used to filter the flood of unrelated
    // mutations Customily fires while the user types (character counters,
    // live pricing preview, etc.) — reacting to those is not just wasted
    // work, it's actively dangerous: typing triggers a blur/validate
    // re-render right as the user clicks Next, and if that reposition moves
    // the button between mousedown and mouseup, the click can land on empty
    // space instead — the button silently "doesn't respond".
    function isRelevantForPlacement(node) {
      if (node.nodeType !== 1) {
        return false;
      }
      return node.classList.contains('customily_option')
        || node.classList.contains('customily-nav-buttons')
        || (node.querySelector && node.querySelector('.customily_option, .customily-nav-buttons'));
    }

    // Customily renders its options asynchronously, so watch for them
    // rather than assuming they exist yet — this also catches secondary
    // (float-left / float-left-single) options added later, and a
    // monogram style adding or removing a whole extra primary option,
    // either of which buildTabs() re-evaluates and rebuilds for if needed.
    var watcher = new MutationObserver(function(mutations) {
      if (!container.querySelector('.customily_option')) {
        return;
      }

      var relevant = mutations.some(function(m) {
        return Array.prototype.some.call(m.addedNodes, isRelevantForPlacement)
          || Array.prototype.some.call(m.removedNodes, isRelevantForPlacement);
      });

      if (!container.dataset.tabsBuilt || relevant) {
        buildTabs();
      }

      if (!container.dataset.tabsBuilt) {
        return;
      }

      syncSecondaryOptions();
      // retry nav-button placement for any primary option whose
      // .cl-option-content wasn't rendered yet the first time — looked up
      // fresh in case Customily has since replaced the option's DOM node
      primaryOptionNames.forEach(function(name, index) {
        var option = getLiveOption(name);
        if (option) {
          ensureNavButtons(option, index);
          ensureOptionHeading(option, name);
        }
      });
      // Customily can replace and re-collapse a single primary option's
      // node (most often Monogram Style) without ever changing the set of
      // option names, so buildTabs() alone wouldn't catch that here - see
      // reopenFirstTabIfNoneExpanded's own comment for the full story.
      reopenFirstTabIfNoneExpanded();
    });
    watcher.observe(container, { childList: true, subtree: true });

    buildTabs();
  }

  // #customily-personalize-accordion itself may not exist yet at page
  // load (e.g. it only mounts once "Add Monogram" is selected), so watch
  // for the container's own appearance too, not just its children.
  //
  // Customily renders its accordion contents in a rapid burst (dozens of
  // swatch elements, each with input/label/img), which fires many childList
  // mutations at once — this watcher disconnects itself the moment the
  // accordion is found, rather than continuing to run a full-page query on
  // every single one of those mutations (and every mutation anywhere else
  // on the page) for the rest of the page's life, adding CPU contention
  // right when Customily's own rendering needs it least.
  var existingAccordion = document.querySelectorAll('#customily-personalize-accordion');
  if (existingAccordion.length > 0) {
    existingAccordion.forEach(setUpContainer);
  } else {
    var bodyWatcher = new MutationObserver(function() {
      var found = document.querySelectorAll('#customily-personalize-accordion');
      if (found.length > 0) {
        found.forEach(setUpContainer);
        bodyWatcher.disconnect();
      }
    });
    bodyWatcher.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('page:loaded', initCustomilyTabs);

// .customily-right-panel (the preview-canvas column) is entirely
// Customily's own dynamically-rendered markup, not part of the theme, so
// the heading has to be injected once it appears rather than added in Liquid
function initCustomilyPreviewHeading() {
  function addHeading(panel) {
    if (panel.dataset.previewHeadingAdded) {
      return;
    }
    panel.dataset.previewHeadingAdded = 'true';

    var heading = document.createElement('h3');
    heading.className = 'customily-preview-heading';
    heading.textContent = 'Monogram Preview';
    panel.insertBefore(heading, panel.firstChild);
  }

  var existing = document.querySelectorAll('.customily-right-panel');
  if (existing.length > 0) {
    existing.forEach(addHeading);
    return;
  }

  // watches the whole page body since the panel can mount anywhere/anytime
  // (only once the monogram modal opens) — disconnects itself the moment
  // it's found, rather than running a full-page query on every DOM
  // mutation for the rest of the page's life
  var watcher = new MutationObserver(function() {
    var panels = document.querySelectorAll('.customily-right-panel');
    if (panels.length > 0) {
      panels.forEach(addHeading);
      watcher.disconnect();
    }
  });
  watcher.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('page:loaded', initCustomilyPreviewHeading);

// Customily already builds its own .preview-message element (with its own
// text and its own show/hide logic tied to whether a style + text have
// been chosen) — confirmed via live DOM inspection. It just renders, by
// default, as a plain sibling block right after .canvas-container rather
// than overlaid on it. Nothing here creates or toggles that message —
// it's only relocated to be a child of .canvas-container (which Fabric.js
// already sets position:relative on), so the position:absolute + inset:0
// CSS rule in pillowbar.css.liquid overlays it correctly. Customily
// remains fully in control of the message's own visibility/content.
function initCustomilyPreviewOverlay() {
  // Same rationale as relocateSaveButton in initCustomilyTabs above:
  // .preview-message is a node Customily's own Vue app renders and tracks
  // internally. Moving it via appendChild() synchronously inside a
  // MutationObserver callback risks racing Vue's own render cycle for that
  // same tick. Deferring to the next animation frame lets that finish
  // first before we touch the node.
  function relocate(message) {
    var container = message.previousElementSibling;
    if (!container || !container.classList.contains('canvas-container') || message.parentNode === container) {
      return;
    }
    window.requestAnimationFrame(function() {
      if (!document.body.contains(message) || !document.body.contains(container) || message.parentNode === container) {
        return;
      }
      container.appendChild(message);
    });
  }

  function scan(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.preview-message'), relocate);
  }

  scan(document);

  // Customily can re-render this panel (new .canvas-container/.preview-message
  // pair) more than once, so this keeps watching rather than disconnecting
  // after the first match
  var watcher = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function(node) {
        if (node.nodeType !== 1) {
          return;
        }
        if (node.classList && node.classList.contains('preview-message')) {
          relocate(node);
        } else if (node.querySelector) {
          scan(node);
        }
      });
    });
  });
  watcher.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('page:loaded', initCustomilyPreviewOverlay);

// hides .preview-message the instant text is typed into any Customily
// text field, rather than waiting on whatever timing Customily's own
// show/hide logic uses. One-directional on purpose — it only forces the
// message hidden, it never forces it back to visible, so it can't fight
// Customily's own logic for showing it again (e.g. if the text is cleared
// but a style is still picked, that's still Customily's call to make).
// Delegated on document with capture so it catches every text field,
// including ones Customily adds/replaces after this runs.
function initCustomilyTextHidesPreviewMessage() {
  document.addEventListener('input', function(event) {
    var target = event.target;
    if (!target.matches || !target.matches('#cl_optionsapp input[type="text"], #cl_optionsapp textarea')) {
      return;
    }
    if (target.value.trim() === '') {
      return;
    }

    // .preview-message's own CSS sets display:flex unconditionally, which
    // would defeat the [hidden] attribute's default display:none — so
    // this hides it via a direct inline style instead, which always wins
    document.querySelectorAll('.preview-message').forEach(function(message) {
      message.style.display = 'none';
    });
  }, true);
}

document.addEventListener('page:loaded', initCustomilyTextHidesPreviewMessage);

// properties[Placement] swatches — Customily sets width/height on these
// with an inline `!important`, which no external stylesheet rule can ever
// beat (inline + !important outranks a stylesheet's !important at the same
// origin). The only way to override it is to rewrite the same inline
// declaration directly, and since Customily can re-apply its own style at
// any point (image load, re-render, etc.), this keeps re-asserting ours
// via a scoped MutationObserver rather than setting it once and hoping.
function initPlacementSwatchSize() {
  var SWATCH_SIZE = '150px';

  var SWATCH_PROPS = ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height'];

  function applySize(el) {
    SWATCH_PROPS.forEach(function(prop) {
      if (el.style.getPropertyValue(prop) !== SWATCH_SIZE || el.style.getPropertyPriority(prop) !== 'important') {
        el.style.setProperty(prop, SWATCH_SIZE, 'important');
      }
    });
  }

  // the swatch-container CSS elsewhere relies on `input:checked ~ label`,
  // meaning each input is a preceding sibling of its label (not nested
  // inside it) under a shared per-swatch wrapper — so the matching input
  // is looked up as the label's previous sibling, falling back to a
  // parent-scoped query in case that structure ever varies
  function applyValueCaption(label) {
    var next = label.nextElementSibling;
    if (next && next.classList.contains('customily-swatch-value')) {
      return;
    }

    var input = label.previousElementSibling;
    if (!input || input.tagName !== 'INPUT') {
      input = label.parentNode ? label.parentNode.querySelector('input') : null;
    }
    if (!input || !input.value) {
      return;
    }

    var caption = document.createElement('span');
    caption.className = 'customily-swatch-value';
    caption.textContent = input.value;
    label.parentNode.insertBefore(caption, label.nextSibling);
  }

  function applyToContainer(container) {
    Array.prototype.forEach.call(
      container.querySelectorAll('.swatch-container label, .swatch-container label img, .swatch-container label div'),
      applySize
    );
    Array.prototype.forEach.call(
      container.querySelectorAll('.swatch-container label'),
      applyValueCaption
    );
  }

  function watchContainer(container) {
    if (container.dataset.placementSwatchSized) {
      return;
    }
    container.dataset.placementSwatchSized = 'true';

    applyToContainer(container);

    var watcher = new MutationObserver(function() {
      applyToContainer(container);
    });
    watcher.observe(container, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  }

  // watchContainer is a no-op on a container it's already watching (guarded
  // by dataset.placementSwatchSized), so calling it repeatedly on the same
  // still-live container below is harmless - it only does real work the
  // first time it sees a given container element.
  var everFound = false;

  var existing = document.querySelectorAll('.customily_option.placement-swatch');
  if (existing.length > 0) {
    everFound = true;
    existing.forEach(watchContainer);
  }

  // the Placement option (like the rest of Customily's UI) doesn't exist
  // in the DOM until the modal is opened, so watch for its appearance too -
  // and keep watching even after it's found once. Customily re-renders its
  // panels as a Vue app: switching a style/color/variant option can replace
  // a .customily_option.placement-swatch container wholesale (a fresh DOM
  // node, not just changed children) rather than mutating it in place, which
  // detaches the per-container MutationObserver watchContainer attached to
  // the old node - the replacement's own inline sizing (Customily's native
  // default, not ours) would never get overridden without this still
  // running to catch it. Only give up (and stop paying for a body-wide
  // childList+subtree observer, about as broad as they get) if Placement
  // never showed up at all within a bounded window - that case means this
  // product has no Placement option (it's optional per-product) and never
  // will for the rest of this page's life, matching the same
  // give-up-after-N-seconds pattern used for the monogram default-choice
  // enforcement above.
  var bodyWatcher = new MutationObserver(function() {
    var found = document.querySelectorAll('.customily_option.placement-swatch');
    if (found.length > 0) {
      everFound = true;
      found.forEach(watchContainer);
      window.clearTimeout(bodyWatcherTimeout);
    }
  });
  bodyWatcher.observe(document.body, { childList: true, subtree: true });

  var bodyWatcherTimeout = window.setTimeout(function() {
    if (!everFound) {
      bodyWatcher.disconnect();
    }
  }, 15000);
}

document.addEventListener('page:loaded', initPlacementSwatchSize);

// .modal-wrapper.showModal is the confirmed signal for the Customily
// modal being open (also used by other modals in this theme, e.g. the
// Determine Your Density tool-tip). lock-scroll/modal-open on <html> are
// the theme's own established scroll-lock classes (see the mobile-menu
// toggle in pillowbar.js.liquid, and .supports-touch.lock-scroll in
// theme.css.liquid) — reusing them keeps this consistent with every
// other modal instead of introducing a separate mechanism.
function initModalScrollLockClasses() {
  var htmlEl = document.documentElement;

  function syncLockClasses() {
    var isOpen = !!document.querySelector('.modal-wrapper.showModal') ||
      !!document.querySelector('tool-tip[data-tool-tip-open="true"]');
    htmlEl.classList.toggle('lock-scroll', isOpen);
    htmlEl.classList.toggle('modal-open', isOpen);
  }

  syncLockClasses();

  // attribute-filtered (not childList/subtree) so this only reacts to
  // actual class changes, not the flood of unrelated DOM mutations
  // Customily's own rendering fires constantly
  var watcher = new MutationObserver(syncLockClasses);
  watcher.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
}

document.addEventListener('page:loaded', initModalScrollLockClasses);

/*============================================================================
  YOTPO REVIEWS (CUSTOM) — fetches reviews directly from Yotpo's public
  Reviews API client-side (app key is a public identifier, no secret
  needed for reads) and features the single most recent review meeting
  the section's minimum star rating, instead of using Yotpo's own
  embedded widget.
==============================================================================*/
function initYotpoCustomReviews() {
  var containers = document.querySelectorAll('[data-yotpo-custom-reviews]');

  containers.forEach(function(container) {
    if (container.dataset.yotpoBound) { return; }
    container.dataset.yotpoBound = 'true';

    var appKey = container.dataset.appKey;
    var productId = container.dataset.productId;
    var minScore = parseInt(container.dataset.minScore, 10) || 5;

    var boxEl = container.querySelector('[data-yotpo-reviews-list]');
    var starsEl = container.querySelector('[data-yotpo-reviews-summary]');
    var quoteEl = container.querySelector('[data-yotpo-review-quote]');
    var nameEl = container.querySelector('[data-yotpo-review-name]');

    if (!appKey || !productId || !boxEl) { return; }

    // ask for enough recent reviews to find one that qualifies, and sort
    // explicitly by date descending rather than trusting the API's
    // default order — that default was returning stale results
    var url = 'https://api.yotpo.com/v1/widget/' + appKey + '/products/' + productId + '/reviews.json?per_page=20&page=1&sort=date&direction=desc';

    function starsMarkup(score) {
      var rounded = Math.round(score || 0);
      var html = '';
      for (var i = 1; i <= 5; i++) {
        html += '<span class="yotpo-featured-review__star' + (i <= rounded ? ' is-filled' : '') + '">&#9733;</span>';
      }
      return html;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function renderFeaturedReview(review) {
      // no qualifying review — leave the whole section hidden
      if (!review) { return; }

      var name = escapeHtml(review.user && review.user.display_name ? review.user.display_name : 'Anonymous');

      starsEl.innerHTML = starsMarkup(review.score);
      quoteEl.textContent = review.content || '';
      nameEl.textContent = name;
      container.hidden = false;
    }

    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var reviews = (data.response && data.response.reviews) || [];
        // don't trust the API's returned order — sort by date ourselves
        // so the newest qualifying review always wins
        reviews.sort(function(a, b) {
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        });
        var featured = reviews.find(function(review) { return (review.score || 0) >= minScore; });
        renderFeaturedReview(featured);
      })
      .catch(function(err) {
        console.error('Yotpo reviews fetch failed', err);
      });
  });
}

document.addEventListener('page:loaded', initYotpoCustomReviews);



